<template>
  <footer id="footer" class="bfc">
    <div :class="isMobile()?'footer-nav-mobile':'footer-nav'">
      <ul >
        <li>
          <img src="@/assets/images/logo.png" alt="" class="logoImg" style="padding-right: 10px"  />
        </li>
      </ul>

      <ul>
        <li >职位</li>
        <li>关于地保</li>
      </ul>

      <ul>
        <li>业务以服务</li>
        <li>常见问题</li>
      </ul>

      <ul>
        <li>
          <span>联系电话：13718790260</span>
        </li>
        <li>
          <span>电子邮箱：1321788571@qq.com</span>
        </li>
      </ul>



    </div>
    <div class="footer-copyright">
      <p>
        Copyright © 2024 东方地保 |

        <a style="cursor: pointer;text-decoration:none;color: white" href="https://beian.miit.gov.cn" target="_blank">备案号:闽ICP备2024071965号</a>
      </p>
    </div>
  </footer>
</template>
<script>
import home from "@/api/home";

export default {
  name: "Footer",
  data() {
    return {
      liWidthPx: this.isMobile()?'12px':'14px', // 初始颜色为透明
      backgroundImg: "",
      recordNumber:'',
      tecSupport:'',

    };
  },
  mounted() {
    home.getData('').then(rs => {
      this.backgroundImg = rs.data.backgroundImg
      this.recordNumber =rs.data.recordNumber
      this.tecSupport=rs.data.tecSupport
      // this.guildQuest=rs.guildQuest
    })
  },
};
</script>
<style lang="less" scoped>


.sidebar {
  position: fixed;
  top: 20%;
  right: 50px;
  padding: 0 12px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
}
.sidebar .sidebar-item {
  position: relative;
  display: flex;
  justify-content: center;
  padding: 17px 0;
}
.sidebar .sidebar-item .sidebar-img {
  cursor: pointer;
  z-index: 99;
}
.sidebar .sidebar-item .sidebar-content {
  opacity: 0;
  position: absolute;
  top: 0;
  right: 30px;
  width: 0;
  text-align: center;
  background: #fff;
  box-sizing: border-box;
  border-radius: 10px 0 0 10px;
  overflow: hidden;
  transform: translateX(40px);
  transition: all .3s;
}
.sidebar .sidebar-item .sidebar-content .top {
  background: #f4bc20;
  padding: 6px 0;
  color: #fff;
}
.sidebar .sidebar-item .sidebar-content .content {
  padding: 10px 0;
}
.sidebar .sidebar-item .sidebar-content .content > img {
  width: 120px;
  height: 120px;
}
.sidebar .sidebar-item .back-top {
  height: 36px;
  line-height: 36px;
  top: 16px;
}
.sidebar .sidebar-item:hover > .sidebar-content {
  opacity: 1;
  width: 150px;
  transform: translateX(-10px);
}
.sidebar #backToTop {
  display: none;
  list-style: none;
}
footer {
  position: relative;
  color: #ddd;
  background-color: #333;
  width: 100%;
  .footer-nav {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 2fr 1fr 1fr;
    width: 80%;
    max-width: 1200px;
    padding: 40px 0 0;
    margin: 0 auto;
    & > ul {
      margin: 0;
      & > li {
        list-style: none;
        font-size: 14px;
        line-height: 30px;
        color: #dddddd;
        cursor: pointer;
        & > img {
          width: 110px;
        }
      }
      .contact {
        color: #aaaaaa;
      }
    }
    .img-li {
      text-align: center;
    }
  }
  .footer-nav-mobile {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 2fr 1fr 1fr;
    width: 90%;
    //max-width: 1200px;
    padding: 20px 0 0;
    margin: 0 auto;
    & > ul {
      margin: 0;
      width: 80px;
      & > li {
        list-style: none;
        font-size: 14px;
        line-height: 30px;
        color: #dddddd;
        cursor: pointer;
        & > img {
          width: 110px;
        }
      }
      .contact {
        color: #aaaaaa;
      }
    }
    .img-li {
      text-align: center;
    }
  }
  .footer-copyright {
    color: #a5a5a5;
    font-size: 12px;
    line-height: 30px;
    text-align: center;
  }
}
</style>
